import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const additionalChargeUnitsAdapter = getAdapter({ idFieldName: 'value' });

const additionalChargeUnitsSlice = createSlice({
  name: 'additionalChargeUnits',
  initialState: additionalChargeUnitsAdapter.getInitialState(),
  reducers: {
    setAdditionalChargeUnits: (state, { payload: { additionalChargeUnits } }) => {
      additionalChargeUnitsAdapter.setAll(state, additionalChargeUnits);
    }
  }
});

const selectors = additionalChargeUnitsAdapter.getSelectors(({ additionalChargeUnits }) => additionalChargeUnits);

export const getAdditionalChargeUnits = state => selectors.selectAll(state);

export const { setAdditionalChargeUnits } = additionalChargeUnitsSlice.actions;

export default additionalChargeUnitsSlice.reducer;
